import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../../config/apiRouting';
import authenticatedFetch from '../../utils/authenticatedFetch';
import './EscalationBanner.css';

interface Props {
  storeId: string;
  onNavigateToRecovery: (filter?: string) => void;
}

export const EscalationBanner: React.FC<Props> = ({ storeId, onNavigateToRecovery }) => {
  const [overdueCount, setOverdueCount] = useState(0);

  useEffect(() => {
    if (!storeId) return;
    const check = async () => {
      try {
        const response = await authenticatedFetch(API_ENDPOINTS.recoveryWorkflows(storeId, 'OVERDUE'));
        if (response.ok) {
          const data = await response.json();
          setOverdueCount(data.count || 0);
        }
      } catch { /* silent */ }
    };
    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, [storeId]);

  if (overdueCount === 0) return null;

  return (
    <div className="escalation-banner" onClick={() => onNavigateToRecovery('OVERDUE')}>
      <div className="banner-pulse"></div>
      <i className="fas fa-exclamation-triangle"></i>
      <span>{overdueCount} overdue guest recovery workflow{overdueCount > 1 ? 's' : ''} require attention</span>
      <button className="banner-action">View Now</button>
    </div>
  );
};
